export default __webpack_public_path__ + "static/join-7ba566a92fad07f32de75c5bc551248f.jpg";